import { useState } from 'react';
import useSWRInfinite from 'swr/infinite';

import { cachedApiFetcher } from 'lib/swr';
import CommunityGrid from 'components/community/gridV2/CommunityGrid';
import { CommunityGridItem, CommunityPost } from 'types/community';

import styles from './CommunityView.module.css';

type Props = {
  initialGridItems?: CommunityGridItem[];
  isFeatured?: boolean;
  selectedTag?: string;
};

export function gridItemHandler(data: any) {
  return data.map((p: any) => CommunityPost.fromAPI(p).toCommunityGridItem());
}

function getCommunityPostUrl(tagTitle?: string, before?: Number) {
  const params: Record<string, string> = {
    limit: '20',
  };
  if (tagTitle) {
    params.tag = tagTitle;
  }
  if (before) {
    params.before = before.toString();
  }

  const queryString = new URLSearchParams(params).toString();
  const endpoint = '/api/community-posts';
  return queryString ? `${endpoint}?${queryString}` : endpoint;
}

export default function CommunityView({ selectedTag }: Props) {
  const [hasMoreItems, setHasMoreItems] = useState<boolean>(true);

  function getUrl(
    pageIndex: number,
    previousPageData: CommunityGridItem[] | null
  ) {
    if (pageIndex === 0) {
      return getCommunityPostUrl(selectedTag as string);
    }

    if (previousPageData === null || previousPageData.length === 0) {
      setHasMoreItems(false);
      return null;
    }

    const before =
      previousPageData[previousPageData.length - 1].communityRevisionId;

    return getCommunityPostUrl(selectedTag as string, before);
  }

  const {
    data: loadedGridItems,
    setSize,
    isValidating,
  } = useSWRInfinite(getUrl, cachedApiFetcher(gridItemHandler), {
    initialSize: 1,
    revalidateFirstPage: false,
  });

  function onScrollNearEnd() {
    setSize((size) => size + 1);
  }

  return (
    <div className={styles.Container}>
      <CommunityGrid
        gridItems={loadedGridItems?.flat()}
        hasMoreItems={hasMoreItems}
        isValidating={isValidating}
        onScrollNearEnd={onScrollNearEnd}
      />
    </div>
  );
}
